import { initAjaxErrorHandler } from './ajax-error';
import { initBootstrapComponents } from './bootstrap';
import { initMenu } from './menu';
import {
    bindDatagridDelegates,
    bindFloatTheadNavigationGuards,
    cleanupOrphanFloatTheadContainers,
    destroyAllFloatedTables,
    initDatagridConfirmDialogs,
    initDatagridFilterSelects,
    initDatagridOrdering,
    initDatagridRowsPerPageSelect,
} from './datagrid';
import { initFileInputUploads } from './file-input-upload';
import { initEntityItemsControls } from './entity-items';
import { initFormSelects } from './forms';
import { initNativeChecks } from './native-checks';
import { initLayoutFlashes } from './notifications';
import { initRangeLinks } from './range-link';
import { initSystemModule } from './systemModule';
import { initLucideIcons } from './lucide-icons';

function afterAjax(): void {
    const isLogin = document.body.classList.contains('nais-login');
    const loginRoot = document.getElementById('snippet--loginForm') ?? document.querySelector('.nais-login__form');

    if (isLogin) {
        if (loginRoot) {
            initBootstrapComponents(loginRoot);
        }
        initNativeChecks(loginRoot ?? document);
        initLayoutFlashes();
        initLucideIcons(loginRoot ?? document);
        return;
    }

    // Drop sticky floatThead clones left on `.nais-main` after leaving a grid page.
    cleanupOrphanFloatTheadContainers();

    initLayoutFlashes();
    initBootstrapComponents();
    initMenu();
    initNativeChecks();
    initFileInputUploads();
    initEntityItemsControls();
    if (typeof window.initCalendars === 'function') {
        window.initCalendars();
    }
    initRangeLinks();
    if (typeof window.initCheckboxesBulkActions === 'function') {
        window.initCheckboxesBulkActions();
    }
    if (typeof window.initEntitiesTables === 'function') {
        window.initEntitiesTables();
    }
    if (typeof window.initEntitiesAutocomplete === 'function') {
        window.initEntitiesAutocomplete();
    }
    if (typeof window.init_datagrid === 'function') {
        // URL lives on each .nais-datagrid-search__input[data-search-url].
        window.init_datagrid();
    }
    initDatagridRowsPerPageSelect();
    initDatagridFilterSelects();
    initDatagridOrdering();
    initFormSelects();
    initSystemModule();
    initLucideIcons();
}

export function initNetteBridge(): void {
    const $ = window.jQuery;
    if (!$?.nette) return;

    initDatagridConfirmDialogs();
    bindDatagridDelegates();
    initAjaxErrorHandler();

    $.nette.ext({
        before() {
            // Clones live on `.nais-main` / SD scroll host — destroy before snippet
            // replace, otherwise refreshDatagrid leaves a duplicate thead.
            destroyAllFloatedTables();
        },
        load() {
            if (typeof (window as Window & { CKEDITOR?: unknown }).CKEDITOR !== 'undefined') {
                for (const inst in (window as Window & { CKEDITOR: { instances: Record<string, unknown> } }).CKEDITOR.instances) {
                    (window as Window & { CKEDITOR: { instances: Record<string, { updateElement: () => void }> } }).CKEDITOR.instances[inst].updateElement();
                }
            }
            afterAjax();
        },
    });

    $(() => {
        bindFloatTheadNavigationGuards();
        $.nette.init();
        afterAjax();
    });
}
